<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-19 00:35:55
 * @LastEditors: Please set LastEditors
 -->

<template>
    <el-dialog
            title="产品搜索"
            :visible="true"
            width="60%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">

            <el-form-item label="选择出货商品:" prop="product_sn">
                <el-col :span="4">
                    <el-input v-model="form.product_sn" readonly></el-input>
                </el-col>
                <el-col class="line" :span="1" style="text-align: center">-</el-col>
                <el-col :span="8">
                    <el-input v-model="form.product_name" readonly></el-input>
                </el-col>
                <el-col :span="4" style="margin-left: 20px">
                    <el-button type="primary" @click="choose()" v-if="isShow">选择</el-button>
                </el-col>
            </el-form-item>
            <el-form-item label="生产批次号:" v-if="isCodeShow" prop="isCodeShow">
                <el-col :span="8">
                    <el-input v-model="form.production_batch" readonly></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="订单数量:" prop="orderNum">
                <el-col :span="8">
                    <el-input v-model="form.orderNum" type="number" ></el-input>
                </el-col>
            </el-form-item>
            <el-form-item>
                <el-col :span="8">
                    <el-button type="primary" @click="save('form')">保存</el-button>
                </el-col>
            </el-form-item>

        </el-form>

        <selectProduct
                v-if="selectProductDialog"
                v-on:handleClose = 'selectProductDialog = false'
                v-on:pushData="getChildData"
        >
        </selectProduct>
    </el-dialog>
</template>

<script>
    import selectProduct from './selectProduct';
    import { Message } from 'element-ui';
    export default {
        name: "addProduct",
        data () {
            return {
                selectProductDialog:false,
                form: {
                    product_sn:'',
                    product_name:'',
                    production_batch:'',
                    orderNum:''
                },
                productData:{},//选择的产品信息，传给添加出库单的列表显示
                isShow:true,
                flag:'',//编辑的时候传递出库单号
                isCodeShow:true,
                rules: {
                    product_sn: [
                        { required: true, message: '请输入产品信息', trigger: 'blur' },
                    ],
                    production_batch: [
                        { required: true, message: '请输入生产批次号', trigger: 'blur' }
                    ],
                    orderNum: [
                        { required: true, message: '请输入数量', trigger: 'blur' }
                    ]
                }
            }
        },
        props:{
            type:Number
        },
        methods:{
            getConfigInfo(){
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    console.log(res);
                    if(res.data.production_batch_on_off == 0){
                        this.isCodeShow = false;

                    }else if(res.data.production_batch_on_off == 1){
                        this.isCodeShow = true;

                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            choose(){
                this.selectProductDialog = true;
            },
            //直接添加获取子组件传过来的产品信息
            getChildData(val){
                //console.log(val);
                this.productData = val;
                this.form.product_sn = val.product_sn;
                this.form.product_name = val.product_name;
                this.form.production_batch = val.production_batch;
            },
            save(){
                var that =this;
               
       
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if(this.form.orderNum == 0){
                            Message.error('数量不能为0');
                            return false;
                        }
                      
                        if(this.type && this.type == 2){
                            /*接口报500*/
                            let url = '/outwarehouses/' +this.stock_out_sn+'/products'
                            this.$post('logistics',url, {
                                outwarehouse:this.stock_out_sn,
                                lang:'',
                                production_batch:this.productData.production_batch,
                                product_sn:this.productData.product_sn,
                                stock_out_num:this.form.orderNum
                            }).then(res => {
                                console.log(res);
                                  setTimeout(function(){
                                that.$emit('refresh');
                                that.$emit('handleClose');
                            },1000)

                                
                            }).catch(function (error) {
                                console.log(error);
                                    setTimeout(function(){
                                that.$emit('refresh');
                                that.$emit('handleClose');
                            },1000)
                                });
                            //执行的顺序问题，奢姿定时器来延后执行
                        
                            return;
                        }
                        if(this.type && this.type == 3){
                            let url = '/outwarehouses/' + this.stock_out_sn+'/products/' + this.editInfo.id;
                            this.$patch('logistics',url, {
                                _method:'PATCH',
                                outwarehouse:this.stock_out_sn,
                                lang:'',
                                oproductid:this.editInfo.id,
                                stock_out_num:this.form.orderNum
                            }).then(res => {
                            
                                if(res.message == '操作成功'){
                                    this.$message({
                                        type: 'success',
                                        message: '修改成功!'
                                    });
                             setTimeout(function(){
                                that.$emit('refresh');
                                that.$emit('handleClose');
                            },1000)
                                }
                            }).catch(error =>{
                                this.$message({
                                    type: 'error',
                                    message: error.message
                                });
                                    setTimeout(function(){
                                that.$emit('refresh');
                                that.$emit('handleClose');
                            },1000)

                            });
                            //执行的顺序问题，奢姿定时器来延后执行
                            // setTimeout(function(){
                            //     that.$emit('refresh');
                            //     that.$emit('handleClose');
                            // },1000)

                            return;
                        }
                   
                        if(this.type && this.type == 1){
                           
                            this.tableData[this.editIndex].stock_out_num = this.form.orderNum;

                            this.$emit('pushData',this.tableData);
                            this.$emit('handleClose');
                            return;
                        }
                        this.productData.stock_out_num = this.form.orderNum;
                        this.productData.real_stock_out_num = 0;
                        //查重
                        if(this.tableData.length && this.tableData.length > 0){
                            let flag = 0;
                            for(var i = 0; i < this.tableData.length;i++){
                                if(this.tableData[i].id == this.productData.id){
                                    this.$message({
                                        message: '已经存在相同的产品',
                                        type: 'warning'
                                    });
                                    break;
                                }else{
                                    flag++;
                                }
                            }
                            if(flag == this.tableData.length){
                                this.tableData.push(this.productData);
                                this.$emit('pushData',this.tableData);
                                this.$emit('handleClose');
                            }else{
                                this.$message({
                                    message: '已经存在相同的产品',
                                    type: 'warning'
                                });
                            }
                        }else{
                            this.tableData.push(this.productData);
                            this.$emit('pushData',this.tableData);
                            this.$emit('handleClose');
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created(){
            this.getConfigInfo();
            if(this.type && this.type == 3){
                this.isShow = false;
                this.form.orderNum = this.tableData[this.editIndex].stock_out_num;
                this.form.product_sn = this.tableData[this.editIndex].product_sn;
                this.form.product_name = this.tableData[this.editIndex].product_name;
                this.form.production_batch = this.tableData[this.editIndex].production_batch;
                this.productData = this.tableData[this.editIndex];
            }
            //获取产品的详情
            if(this.editIndex !== -1 && this.type == 1){
                this.isShow = false;
                this.form.orderNum = this.tableData[this.editIndex].stock_out_num;
                this.form.product_sn = this.tableData[this.editIndex].product_sn;
                this.form.product_name = this.tableData[this.editIndex].product_name;
                this.form.production_batch = this.tableData[this.editIndex].production_batch;
                this.productData = this.tableData[this.editIndex];
            }
            if(this.type && this.type == 2){
                this.isShow = true;
            }

        },
        mounted(){
         

        },
        components:{
            selectProduct
        },
        props: {
            editInfo: {
                type: Object,
                default: function(){
                    return
                }
            },
            //添加出库单添加产品和编辑的时候避免重复添加
            tableData:{
                type: Array,
                default:[]
            },
            editIndex:{
                type:Number,
                default:0
            },
            type:{
                type:Number,
                default:0
            },
            stock_out_sn:{
                type:String,
                default:''
            }
        },
    }
</script>


<style lang="scss" scoped>

</style>